import styled from "styled-components";
import Text from "./Text";
const InputErrorText = styled(Text)`
  color: #fb4eff;
  font-size: 12px;
`;

export default InputErrorText